/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SpecialTabInfo } from './specialTabInfo';
import { MetaPage } from './metaPage';
import { ParentFields } from './parentFields';


/**
 * Group of fields
 */
export interface MetaGroup { 
    /**
     * Fields pages
     */
    pages?: Array<MetaPage> | null;
    specialTabInfo?: SpecialTabInfo;
    /**
     * Element id
     */
    id: number;
    /**
     * Position for element
     */
    position: number;
    /**
     * Pseudo script indicating which control should be initialized in this tab
     */
    formHint_Operator?: string | null;
    /**
     * Element name on form
     */
    formCaption?: string | null;
    /**
     * Field name
     */
    fieldName?: string | null;
    /**
     * Is visible for operator in table
     */
    isVisibleTableOperator: boolean;
    /**
     * Is visible for operator on form
     */
    isVisibleOperator: boolean;
    /**
     * Is visible for client in table
     */
    isVisibleTableClient: boolean;
    /**
     * Is visible for client on form
     */
    isVisibleClient: boolean;
    fieldsRules?: ParentFields;
}

